<section class="white-bg transition-none" id="contact">
  <div class="container">
    <div class="row">
      <div class="col-md-8 centerize-col text-center">
        <div class="section-title">
          <h2
            class="brand-mark"
            [appSplitText]="'home.design.contactLabel' | translate"
            splitMode="reveal"
          ></h2>
          <h2
            [appSplitText]="'home.design.contactTitle' | translate"
            splitMode="reveal"
          ></h2>
        </div>
        <p appReveal="rise" revealDelay="0.15">
          {{ "home.contact.descr" | translate }}
        </p>
      </div>
    </div>
  </div>

  <div class="container address-wrapper">
    <div class="address">
      <div class="col-md-6 col-sm-6 col-xs-12" appReveal="rise" revealBatch>
        <div class="section-title">
          <h2>
            {{ "home.contact.number" | translate }}
          </h2>
          <p class="mb-0 mt-30">
            <a class="contact-phone" href="tel:+37441885885"
              ><i class="icofont icofont-ui-call dv-ring" aria-hidden="true"></i>+374 41885885</a
            >
          </p>
        </div>
      </div>

      <div class="col-md-6 col-sm-6 col-xs-12" appReveal="rise" revealBatch>
        <div class="section-title">
          <h2>
            <span class="brand-icon brand-icon--location contact-pin" aria-hidden="true"></span>
            {{ "home.contact.address-header" | translate }}
          </h2>
          <p class="mb-0 mt-30">
            {{ "home.contact.address" | translate }}
          </p>
        </div>
      </div>
    </div>

    <!-- Opacity-only reveal: the iframe and the map never get a transform. -->
    <div #leadForm class="lead-form" aria-label="Lead form" appReveal="fade" data-lenis-prevent>
      <iframe
        src="https://b24-luyafr.bitrix24.site/crm_form_ptqho/"
        title="Callback lead form"
        loading="lazy"
        scrolling="no"
      ></iframe>
    </div>

    <div class="map" appReveal="fade" data-lenis-prevent>
      <google-map *ngIf="mapsReady; else mapFallback" height="100%" width="100%" [center]="center" [zoom]="zoom">
        <map-marker
          *ngIf="latLng"
          [position]="latLng"
          [options]="markerOptions"
        ></map-marker>
      </google-map>

      <ng-template #mapFallback>
        <a
          class="contact-map-fallback"
          href="https://www.google.com/maps/search/?api=1&amp;query=40.182989,44.520092"
          target="_blank"
          rel="noopener"
        >
          <span class="brand-icon brand-icon--location contact-map-fallback__pin" aria-hidden="true"></span>
          <span class="contact-map-fallback__address">{{ "home.contact.address" | translate }}</span>
          <span class="contact-map-fallback__cta"
            >Google Maps <i class="icofont icofont-external-link dv-arrow" aria-hidden="true"></i
          ></span>
        </a>
      </ng-template>
    </div>
  </div>
</section>
